import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DesktopRedirectPage } from '../shared/desktop-redirect/desktop-redirect.page';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class DesktopRedirectService {
  constructor(private modalController: ModalController, private userService: UserService) {}

  showDesktopRedirect = async (showDesktopRedirect: boolean) => {
    if (showDesktopRedirect) {
      const modal = await this.modalController.create({
        component: DesktopRedirectPage,
        cssClass: 'fullscreen',
      });
      return await modal.present().then(() => {
        this.userService.user.setDesktopRedirect(false);
      });
    }
  };
}
